import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleLoginButton from '../components/GoogleLoginButton';
import LoadingScreen from '../components/LoadingScreen';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { isAuthenticated, isLoading, needsCompany } = useAuth();
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(needsCompany ? '/setup-company' : '/dashboard');
    }
  }, [isAuthenticated, isLoading, needsCompany, navigate]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isLoggingIn) {
    return (
      <LoadingScreen
        text="Вход в систему..."
        subtext="Подождите, идёт авторизация"
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Fin Calendar</h1>
          <p className="text-gray-600 mt-2">Войдите для управления расходами</p>
        </div>

        <div className="flex justify-center">
          <GoogleLoginButton
            onLoginStart={() => setIsLoggingIn(true)}
            onLoginError={() => setIsLoggingIn(false)}
          />
        </div>

        <p className="text-center text-sm text-gray-500 mt-6">
          Вход через Google аккаунт
        </p>
      </div>
    </div>
  );
};

export default Login;
